import { ExpandMore } from "@clockwise/design-system/icons";
import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import React from "react";

const useStyles = makeStyles({
  accordionRoot: {
    "&::before": {
      display: "none",
    },

    "& .MuiIconButton-root": {
      padding: 0,
      marginRight: "6px !important",
    },
  },
  summary: {
    minHeight: 48,
    "&.Mui-expanded": {
      minHeight: 48,
    },
    "& > div:first-child": {
      margin: "12px 0px",
    },
  },
});

export const ExpandableHelpText = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles();
  return (
    <Accordion className={classnames(classes.accordionRoot, "cw-border-0 cw-shadow-none")}>
      <AccordionSummary
        expandIcon={<ExpandMore fontSize="small" className="cw-text-slate-standard cw-w-6" />}
        className={classnames(classes.summary, "cw-flex-row-reverse cw-p-0")}
      >
        <div className="cw-body-base cw-text-slate-darker cw-font-bold">How does this work?</div>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
